module.exports = __webpack_public_path__ + "assets/c7ce82ff0b656313f352498b30c83f01.png";